export function addCurrent(calledservicesettings) {
  return {
      type: 'ADD_CURRENT',
      calledservicesettings,
  }
}